<template>
	<div class="page-container">
		<!-- 顶部标题栏 -->
		<div class="header">
			<div class="title">新建商品</div>
			<button class="btn-back" @click="goBack">返回列表</button>
		</div>

		<!-- 表单区域 -->
		<div class="form-container">
			<form @submit.prevent="submitForm">

				<!-- 1. 商品类别 (customizeLabelId) -->
				<div class="form-item">
					<label class="form-label required">商品类别</label>
					<div class="form-input-wrapper">
						<el-select ref="labelSelect" v-model="formData.customizeLabelId" clearable filterable remote allow-create
							default-first-option :remote-method="handleCustomizeLabelRemoteSearch" :loading="labelLoading"
							placeholder="请输入或选择商品类别" style="width: 100%;" @change="handleCustomizeLabelChange"
							@blur="handleCustomizeLabelBlur">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
								<div class="label-option">
									<span class="label-option__text">{{ item.label }}</span>
									<i class="el-icon-delete label-option__delete"
										@click.stop.prevent="handleRemoveCustomizeLabel(item)"></i>
								</div>
							</el-option>
						</el-select>
					</div>
				</div>

				<!-- 2. 商品名称 (name) -->
				<div class="form-item">
					<label class="form-label required">商品名称</label>
					<div class="form-input-wrapper">
						<el-select ref="nameSelect" v-model="formData.name" filterable allow-create default-first-option
							placeholder="请输入或选择商品名称" style="width: 100%;" @change="syncNameInput" @blur="syncNameInput">
							<el-option v-for="item in nameOptions" :key="item.value" :label="item.label"
								:value="item.value" />
						</el-select>
					</div>
				</div>

				<!-- 3. 商品数量 -->
				<div class="form-item">
					<label class="form-label">商品数量</label>
					<div class="form-input-wrapper">
						<input type="number" v-model.number="formData.num" class="form-control" placeholder="请输入库存数量">
					</div>
				</div>

        <!-- 4. 商品价格 (price) -->
        <div class="form-item">
          <label class="form-label required">商品价格</label>
          <div class="form-input-wrapper">
            <div class="input-group">
              <span class="prefix">¥</span>
              <input type="number" v-model.number="formData.price" class="form-control" placeholder="0.00"
                step="0.01">
            </div>
          </div>
        </div>

        <!-- 4.1 现价 (currentPrice) -->
        <div class="form-item">
          <label class="form-label required">现价</label>
          <div class="form-input-wrapper">
            <div class="input-group">
              <span class="prefix">¥</span>
              <input type="number" v-model.number="formData.currentPrice" class="form-control" placeholder="0.00"
                step="0.01">
            </div>
          </div>
        </div>

        <!-- 5. 商品主图 (imageUrl) -->
				<div class="form-item">
					<label class="form-label">商品图片</label>
					<div class="form-input-wrapper">
						<el-upload ref="mainUpload" :http-request="customUploadHandler"
							:on-remove="(file, fileList) => handleRemove('main', file, fileList)"
							:on-success="(response, file, fileList) => handleUploadSuccess('main', response, file, fileList)"
							:on-preview="handlePictureCardPreview" :file-list="mainImageFileList" list-type="picture-card"
							:limit="1" :before-upload="beforeUpload" accept="image/jpeg,image/jpg,image/png"
							:data="{ uploadType: 'main' }">
							<i class="el-icon-camera-solid" style="font-size: 16px; color: #fff;"></i>
						</el-upload>
						<div class="tip">仅支持上传1张主图</div>
					</div>
				</div>

				<!-- 6. 商品详情图片 (detailImageUrl) -->
				<div class="form-item">
					<label class="form-label">详情图片</label>
					<div class="form-input-wrapper">
						<el-upload ref="detailUpload" :http-request="customUploadHandler"
							:on-remove="(file, fileList) => handleRemove('detail', file, fileList)"
							:on-success="(response, file, fileList) => handleUploadSuccess('detail', response, file, fileList)"
							:on-preview="handlePictureCardPreview" :file-list="detailImageFileList" list-type="picture-card"
							:limit="9" :multiple="true" :before-upload="beforeUpload" accept="image/jpeg,image/jpg,image/png"
							:data="{ uploadType: 'detail' }">
							<i class="el-icon-camera-solid" style="font-size: 16px; color: #fff;"></i>
						</el-upload>
						<div class="tip">最多上传9张详情图片</div>
					</div>
				</div>

				<!-- 7. 商品详情文本 (detailText) -->
				<div class="form-item">
					<label class="form-label">商品详情</label>
					<div class="form-input-wrapper">
						<textarea v-model="formData.detailText" class="form-control" rows="4"
							placeholder="请输入商品详情"></textarea>
					</div>
				</div>


				<!-- 底部按钮操作区 -->
				<div class="form-actions">
					<button type="button" class="btn btn-cancel" @click="resetForm">重置</button>
					<button type="submit" class="btn btn-submit">保存 </button>
				</div>

			</form>
		</div>
		<el-dialog :visible.sync="dialogVisible" width="520px">
			<img width="100%" :src="dialogImageUrl" alt="" />
		</el-dialog>
	</div>
</template>

<script>
import {
	uploadFile
} from '@/api/api';
import {
	goodsApi
} from "@/api";
export default {
	async created() {
		await this.getCustomizeLabelOptions();
		this.getGoodsNameOptions();
		const editId = this.$route.query.id;
		if (editId) {
			this.editId = editId;
			this.loadGoodsDetail(editId);
		}
	},
	beforeDestroy() {
		if (this.labelSearchTimer) {
			clearTimeout(this.labelSearchTimer);
		}
	},
	data() {
		return {
			options: [],
			nameOptions: [],
			labelLoading: false,
			labelSaving: false,
			labelRemoving: false,
			labelSearchTimer: null,
			editId: null,
			mainImageFileList: [],
			detailImageFileList: [],
			dialogImageUrl: '',
			dialogVisible: false,
			formData: {
				id: null,
				name: "",
				customizeLabelId: null,
				num: null,
				price: null,
				currentPrice: null,
				imageUrl: '',
				detailImageUrl: '',
				detailText: '',
				storeId: null,
				promoGoodsId: null,
			}
		};
	},
	methods: {
		getStoreId() {
			return this.$store.getters['auth/storeId'];
		},
		normalizeId(value) {
			if (value === null || value === undefined || value === '') {
				return null;
			}
			const idNumber = Number(value);
			return Number.isNaN(idNumber) ? value : idNumber;
		},
		normalizeLabelName(value) {
			return typeof value === 'string' ? value.trim() : '';
		},
		mapCustomizeLabelOptions(list) {
			return (list || [])
				.filter(item => item && item.deleted !== true && item.id !== undefined && item.id !== null && this.normalizeLabelName(item.labelName))
				.map(item => ({
					label: this.normalizeLabelName(item.labelName),
					value: this.normalizeId(item.id)
				}));
		},
		findCustomizeLabelByName(labelName) {
			const targetName = this.normalizeLabelName(labelName);
			if (!targetName) {
				return null;
			}
			return this.options.find(item => item.label === targetName) || null;
		},
		async getCustomizeLabelOptions(labelLike = '') {
			this.labelLoading = true;
			try {
				const params = {
					pageNo: 1,
					pageSize: 100,
					storeId: this.getStoreId()
				};
				const keyword = this.normalizeLabelName(labelLike);
				if (keyword) {
					params.labelLike = keyword;
				}
				const response = await goodsApi.queryCustomizeLabelPage(params);
				if ((response.code === 0 || response.code === 200) && response.data) {
					this.options = this.mapCustomizeLabelOptions(response.data.list);
				} else {
					this.$message.error(response.msg || '获取商品类别失败');
				}
			} catch (err) {
				console.error('获取商品类别错误:', err);
				this.$message.error('网络异常，无法获取商品类别');
			} finally {
				this.labelLoading = false;
			}
		},
		handleCustomizeLabelRemoteSearch(query) {
			if (this.labelSearchTimer) {
				clearTimeout(this.labelSearchTimer);
			}
			this.labelSearchTimer = setTimeout(() => {
				this.getCustomizeLabelOptions(this.normalizeLabelName(query));
			}, 300);
		},
		async ensureCustomizeLabel(labelInput) {
			const labelName = this.normalizeLabelName(labelInput);
			if (!labelName) {
				return null;
			}
			const existed = this.findCustomizeLabelByName(labelName);
			if (existed) {
				return existed.value;
			}
			this.labelSaving = true;
			try {
				const preQueryRes = await goodsApi.queryCustomizeLabelPage({
					pageNo: 1,
					pageSize: 100,
					storeId: this.getStoreId(),
					labelLike: labelName
				});
				if ((preQueryRes.code === 0 || preQueryRes.code === 200) && preQueryRes.data) {
					const existedByApi = this.mapCustomizeLabelOptions(preQueryRes.data.list)
						.find(item => item.label === labelName);
					if (existedByApi) {
						if (!this.options.some(item => item.value === existedByApi.value)) {
							this.options.unshift(existedByApi);
						}
						return existedByApi.value;
					}
				}
				const response = await goodsApi.createOrUpdateCustomizeLabel({
					storeId: this.getStoreId(),
					labelName,
					enable: true
				});
				if (!(response.code === 0 || response.code === 200)) {
					this.$message.error(response.msg || '新增商品类别失败');
					return null;
				}
				const queryRes = await goodsApi.queryCustomizeLabelPage({
					pageNo: 1,
					pageSize: 100,
					storeId: this.getStoreId(),
					labelLike: labelName
				});
				if ((queryRes.code === 0 || queryRes.code === 200) && queryRes.data) {
					const matched = this.mapCustomizeLabelOptions(queryRes.data.list)
						.find(item => item.label === labelName);
					if (matched) {
						if (!this.options.some(item => item.value === matched.value)) {
							this.options.unshift(matched);
						}
						return matched.value;
					}
				}
				const createdId = this.normalizeId(response.data);
				if (createdId !== null) {
					const createdOption = {
						label: labelName,
						value: createdId
					};
					this.options.unshift(createdOption);
					return createdId;
				}
				this.$message.error('新增类别成功但未获取到类别ID，请重试');
				return null;
			} catch (err) {
				console.error('新增商品类别错误:', err);
				this.$message.error('网络异常，新增类别失败');
				return null;
			} finally {
				this.labelSaving = false;
			}
		},
		async handleCustomizeLabelChange(value) {
			if (typeof value === 'string') {
				const customizeLabelId = await this.ensureCustomizeLabel(value);
				if (customizeLabelId !== null) {
					this.formData.customizeLabelId = customizeLabelId;
				} else {
					this.formData.customizeLabelId = null;
				}
				return;
			}
			this.formData.customizeLabelId = this.normalizeId(value);
		},
		async handleCustomizeLabelBlur() {
			const query = this.normalizeLabelName(this.$refs.labelSelect && this.$refs.labelSelect.query);
			if (!query) {
				return;
			}
			const selectedId = this.normalizeId(this.formData.customizeLabelId);
			if (selectedId !== null) {
				const selectedOption = this.options.find(item => item.value === selectedId);
				if (selectedOption && selectedOption.label === query) {
					return;
				}
			}
			const existed = this.findCustomizeLabelByName(query);
			if (existed) {
				this.formData.customizeLabelId = existed.value;
				return;
			}
			const createdId = await this.ensureCustomizeLabel(query);
			if (createdId !== null) {
				this.formData.customizeLabelId = createdId;
			}
		},
		async handleRemoveCustomizeLabel(item) {
			if (!item || item.value === null || item.value === undefined || this.labelRemoving) {
				return;
			}
			const targetId = this.normalizeId(item.value);
			try {
				await this.$confirm(`确定删除分类「${item.label}」吗？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				});
				this.labelRemoving = true;
				const response = await goodsApi.removeCustomizeLabel({
					customizeLabelIdList: [targetId]
				});
				if (response.code === 0 || response.code === 200) {
					this.options = this.options.filter(option => option.value !== targetId);
					if (this.normalizeId(this.formData.customizeLabelId) === targetId) {
						this.formData.customizeLabelId = null;
					}
					this.$message.success('分类删除成功');
				} else {
					this.$message.error(response.msg || '分类删除失败');
				}
			} catch (err) {
				if (err !== 'cancel') {
					console.error('删除商品分类错误:', err);
					this.$message.error('网络异常，删除类别失败');
				}
			} finally {
				this.labelRemoving = false;
			}
		},
		beforeUpload(file) {
			const isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
			if (!isImage) {
				this.$message.error('只支持 JPG/PNG 图片！');
				return false;
			}
			const isLt1M = file.size / 1024 / 1024 <= 1;
			if (!isLt1M) {
				this.$message.error('图片大小不能超过 1MB！');
				return false;
			}
			return true;
		},

		extractUploadUrl(fileItem) {
			if (!fileItem) {
				return '';
			}
			const responseData = fileItem.response && (fileItem.response.data || fileItem.response.url || '');
			if (responseData) {
				return responseData;
			}
			if (fileItem.url && !String(fileItem.url).startsWith('blob:')) {
				return fileItem.url;
			}
			return '';
		},

		normalizeDetailFileList(fileList = this.detailImageFileList) {
			return (fileList || [])
				.map((item, index) => {
					const url = this.extractUploadUrl(item);
					if (!url) {
						return null;
					}
					return {
						name: item && item.name ? item.name : `detailImage-${index + 1}`,
						url
					};
				})
				.filter(Boolean)
				.slice(0, 9);
		},

		syncDetailImageUrlFromFileList(fileList = this.detailImageFileList) {
			const urls = (fileList || [])
				.map(item => this.extractUploadUrl(item))
				.filter(Boolean);
			this.formData.detailImageUrl = urls.join(',');
		},

		parseDetailImageUrls(detailImageUrl) {
			if (!detailImageUrl || typeof detailImageUrl !== 'string') {
				return [];
			}
			return detailImageUrl
				.split(',')
				.map(item => item.trim())
				.filter(Boolean);
		},

		handleRemove(uploadType, file, fileList) {
			if (uploadType === 'main') {
				const removedUrl = this.extractUploadUrl(file);
				this.mainImageFileList = (fileList || []).slice(0, 1);
				if (this.mainImageFileList.length) {
					this.formData.imageUrl = this.extractUploadUrl(this.mainImageFileList[0]);
				} else if (!removedUrl || this.formData.imageUrl === removedUrl) {
					this.formData.imageUrl = '';
				}
				return;
			}
			this.detailImageFileList = this.normalizeDetailFileList(fileList);
			this.syncDetailImageUrlFromFileList(this.detailImageFileList);
		},

		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url || (file.response ? file.response.data : '');
			this.dialogVisible = true;
		},

		async customUploadHandler({
			file,
			onSuccess,
			onError,
			data
		}) {
			const isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
			if (!isImage) {
				this.$message.error('仅支持 JPG/PNG 图片！');
				return onError(new Error('不支持的类型'));
			}
			const formData = new FormData();
			formData.append('file', file);
			formData.append('directory', 'pc/goods');
			try {
				const result = await uploadFile(formData);

				if (result.code === 0 || result.code === 200) {
					const imageUrl = result.data;
					const uploadType = data && data.uploadType ? data.uploadType : 'main';

					onSuccess({
						...result,
						data: imageUrl,
						uploadType
					}, file);
				} else {
					throw new Error(result.msg || '上传失败');
				}
			} catch (err) {
				console.error('上传错误:', err);
				this.$message.error(`❌ ${file.name} 上传失败：${err.message}`);
				onError(err);
			}
		},
		handleUploadSuccess(uploadType, response, file, fileList) {
			if (uploadType === 'main') {
				this.mainImageFileList = (fileList || []).slice(0, 1);
				const latestUrl = (response && response.data) || this.extractUploadUrl(file);
				this.formData.imageUrl = latestUrl || '';
				if (this.formData.imageUrl) {
					this.mainImageFileList = [{
						name: file && file.name ? file.name : 'mainImage',
						url: this.formData.imageUrl
					}];
				}
				return;
			}
			const mergedDetailList = (fileList || []).slice(0, 9).map(item => {
				if (item && file && item.uid === file.uid && response && response.data) {
					return {
						...item,
						url: response.data,
						response: {
							...(item.response || {}),
							data: response.data
						}
					};
				}
				return item;
			});
			this.detailImageFileList = this.normalizeDetailFileList(mergedDetailList);
			this.syncDetailImageUrlFromFileList(this.detailImageFileList);
		},
		async getGoodsNameOptions() {
		try {
			const response = await goodsApi.getGoodsList({
				pageNo: 1,
				pageSize: 1000,
				storeId: this.getStoreId()
			});
				if ((response.code === 0 || response.code === 200) && response.data?.list) {
					const nameSet = new Set();
					response.data.list.forEach(item => {
						if (item && item.name) {
							nameSet.add(item.name);
						}
					});
					this.nameOptions = Array.from(nameSet).map(name => ({
						label: name,
						value: name
					}));
				} else {
					this.$message.error(response.msg || '获取商品名称失败');
				}
		} catch (err) {
			console.error('获取商品名称错误:', err);
			this.$message.error('网络异常，无法获取商品名称');
		}
	},
	async loadGoodsDetail(id) {
		try {
			const response = await goodsApi.goodsDetail({
				id
			});
			if (response.code === 0 || response.code === 200) {
				const detail = response.data || {};
				const customizeLabelId = this.normalizeId(detail.customizeLabelId || detail.goodsTypeId || detail.categoryId || null);
				const customizeLabelName = this.normalizeLabelName(detail.customizeLabelName || detail.goodsTypeName || detail.categoryName);
				this.formData = {
					...this.formData,
					id: detail.id || detail.promoGoodsId || id,
					promoGoodsId: detail.promoGoodsId || detail.id || id,
					name: detail.name || '',
					customizeLabelId,
					num: (detail.num !== undefined && detail.num !== null) ? detail.num : null,
					price: (detail.originalPrice !== undefined && detail.originalPrice !== null) ?
						detail.originalPrice :
						(detail.price !== undefined ? detail.price : null),
					currentPrice: (detail.currentPrice !== undefined && detail.currentPrice !== null) ?
						detail.currentPrice :
						null,
					imageUrl: detail.imageUrl || '',
					detailImageUrl: detail.detailImageUrl || '',
					detailText: detail.detailText || detail.desc || '',
					storeId: detail.storeId || this.getStoreId()
				};
				if (customizeLabelId !== null && customizeLabelName && !this.options.some(item => item.value === customizeLabelId)) {
					this.options.unshift({
						label: customizeLabelName,
						value: customizeLabelId
					});
				}
				this.mainImageFileList = this.formData.imageUrl ? [{
					name: 'mainImage',
					url: this.formData.imageUrl
				}] : [];
				const detailImageUrls = this.parseDetailImageUrls(this.formData.detailImageUrl);
				this.detailImageFileList = detailImageUrls.map((url, index) => ({
					name: `detailImage-${index + 1}`,
					url
				}));
			} else {
				this.$message.error(response.msg || '获取商品详情失败');
			}
		} catch (err) {
			console.error('获取商品详情错误:', err);
			this.$message.error('网络异常，无法获取商品详情');
		}
	},
		// 同步商品名称输入值
		syncNameInput(val) {
			if (typeof val === 'string' && val.trim()) {
				this.formData.name = val.trim();
				return;
			}
			const query = this.$refs.nameSelect && this.$refs.nameSelect.query;
			if (query && query.trim()) {
				this.formData.name = query.trim();
			}
		},
		// 提交表单
	async submitForm() {
		if (typeof this.formData.customizeLabelId === 'string') {
			const ensuredId = await this.ensureCustomizeLabel(this.formData.customizeLabelId);
			if (ensuredId === null) {
				return;
			}
			this.formData.customizeLabelId = ensuredId;
		}
		const hasCustomizeLabel = this.formData.customizeLabelId !== null && this.formData.customizeLabelId !== undefined &&
			this.formData.customizeLabelId !== '';
		const hasPrice = this.formData.price !== null && this.formData.price !== undefined && this.formData.price !== '';
		const hasCurrentPrice = this.formData.currentPrice !== null && this.formData.currentPrice !== undefined && this.formData.currentPrice !== '';
		if (!this.formData.name || !hasCustomizeLabel || !hasPrice || !hasCurrentPrice) {
			this.$message.warning('请填写名称、类别、价格和促销价！');
			return;
		}
		const submittedName = this.formData.name && this.formData.name.trim();
		this.formData.name = submittedName;
		try {
			this.formData.imageUrl = this.mainImageFileList.length ? this.extractUploadUrl(this.mainImageFileList[0]) : '';
			this.syncDetailImageUrlFromFileList(this.detailImageFileList);
			this.formData.storeId = this.getStoreId();
			const editId = this.editId || this.formData.id || this.formData.promoGoodsId;
			const payload = {
				...this.formData,
				num: (this.formData.num === '' || this.formData.num === null || this.formData.num === undefined) ? undefined : this.formData.num,
				customizeLabelId: this.normalizeId(this.formData.customizeLabelId),
				originalPrice: this.formData.price,
				currentPrice: this.formData.currentPrice,
			};
			if (payload.num === undefined) {
				delete payload.num;
			}
			delete payload.goodsTypeId;
			if (editId) {
				payload.id = editId;
			} else {
				delete payload.id;
				delete payload.promoGoodsId;
			}
			const response = await goodsApi.newGoods(payload)

			if (response.code === 0 || response.code === 200) {
				const isEdit = !!(payload.promoGoodsId);
				this.$message.success(isEdit ? '商品保存成功！' : '商品添加成功！');
					if (submittedName && !this.nameOptions.some(item => item.value === submittedName)) {
						this.nameOptions.unshift({
							label: submittedName,
							value: submittedName
						});
					}

					// 可选：清空表单
					this.resetForm();

					// 可选：跳转页面
					this.$router.push({
						path: '/goodsList',
						query: {
							refresh: true,
							timestamp: Date.now()
						}
					});
				} else {
					this.$message.error(response.msg || '新增失败');
				}
			} catch (err) {
				console.error('新增商品出错:', err);
				this.$message.error('网络异常，请求提交失败');
			}

		},
		// 重置表单
	resetForm() {
		this.formData = {
			id: null,
			name: "",
			customizeLabelId: null,
			num: null,
			storeId: null,
			imageUrl: "",
			detailImageUrl: "",
				detailText: "",
				price: null,
				currentPrice: null,
				promoGoodsId: null,
			};
			this.mainImageFileList = [];
			this.detailImageFileList = [];
		},
		goBack() {
			this.$router.back();
			// console.log('返回');
		}
	}
};
</script>

<style scoped>
/* 全局容器样式 */
.page-container {
	padding-top: 20px;
	background-color: #f5f7fa;
	min-height: 100vh;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

/* 头部样式 */
.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
	background-color: #fff;
	padding: 15px 20px;
	border-radius: 4px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.title {
	font-size: 18px;
	font-weight: bold;
	color: #333;
	border-left: 4px solid #ff9800;
	/* 橙色 */
	padding-left: 10px;
}

.btn-back {
	background: transparent;
	border: 1px solid #ddd;
	padding: 6px 12px;
	border-radius: 3px;
	cursor: pointer;
	color: #666;
}

/* 表单容器 */
.form-container {
	background-color: #fff;
	padding: 30px;
	border-radius: 4px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	max-width: 800px;
	margin: 0 auto;
}

/* 表单项布局 */
.form-item {
	display: flex;
	align-items: flex-start;
	margin-bottom: 25px;
}

/* 标签样式 */
.form-label {
	width: 120px;
	text-align: right;
	margin-right: 20px;
	padding-top: 8px;
	font-size: 14px;
	color: #606266;
}

.form-label.required::before {
	content: '*';
	color: #f56c6c;
	margin-right: 4px;
}

/* 输入框外层 */
.form-input-wrapper {
	flex: 1;
	max-width: 400px;
}

/* 输入控件通用样式 */
.form-control {
	width: 100%;
	padding: 8px 12px;
	font-size: 14px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	outline: none;
	box-sizing: border-box;
	transition: border-color 0.2s;
	color: #606266;
}

.form-control:focus {
	border-color: #ff9800;
}

/* 带有前缀的输入框 */
.input-group {
	display: flex;
	align-items: center;
	position: relative;
}

.input-group .prefix {
	position: absolute;
	left: 10px;
	color: #909399;
}

.input-group input[type="number"] {
	padding-left: 25px;
}

/* 单选框组样式 */
.radio-group {
	padding-top: 8px;
	display: flex;
	gap: 20px;
}

.radio-label {
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #606266;
	cursor: pointer;
}

.radio-label input {
	margin-right: 5px;
	cursor: pointer;
}

/* 图片上传器样式 */
.image-uploader {
	width: 100px;
	height: 100px;
	border: 1px dashed #d9d9d9;
	border-radius: 4px;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	overflow: hidden;
	background-color: #fbfdff;
}

.image-uploader:hover {
	border-color: #ff9800;
}

.upload-placeholder {
	font-size: 28px;
	color: #8c939d;
}

.preview-image {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.tip {
	font-size: 12px;
	color: #909399;
	margin-top: 6px;
}

/* 底部按钮区 */
.form-actions {
	margin-top: 40px;
	padding-left: 140px;
	display: flex;
	gap: 15px;
}

.btn {
	padding: 10px 25px;
	font-size: 14px;
	border-radius: 4px;
	border: none;
	cursor: pointer;
	transition: opacity 0.2s;
}

.btn:hover {
	opacity: 0.9;
}

.btn-submit {
	background-color: #ff9800;
	color: #fff;
	font-weight: 500;
}

.btn-cancel {
	background-color: #fff;
	border: 1px solid #dcdfe6;
	color: #606266;
}

::v-deep .label-option {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}

::v-deep .label-option__text {
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

::v-deep .label-option__delete {
	color: #c0c4cc;
	font-size: 14px;
	margin-left: 8px;
}

::v-deep .label-option__delete:hover {
	color: #f56c6c;
}

::v-deep .el-upload--picture-card {
	width: 100px !important;
	height: 100px !important;
	line-height: 100px !important;
	background-color: #777A7F;
	border: none;
	border-radius: 4px;
}

/* 已上传的图片项也统一尺寸 */
::v-deep .el-upload-list__item {
	width: 100px !important;
	height: 100px !important;
	border-radius: 4px;
}
</style>
